// Função auxiliar para validar a estrutura do ícone
const validateIcon = (icon) => {
  if (!icon.path || !Array.isArray(icon.path)) {
    console.warn('Icon path deve ser um array');
    return false;
  }
  if (!icon.viewBox) {
    console.warn('Icon viewBox é obrigatório');
    return false;
  }
  return true;
};

// Primeiro declaramos o objeto icons
export const icons = {
  search: {
    path: [
      '<circle cx="11" cy="11" r="8"></circle>',
      '<line x1="21" y1="21" x2="16.65" y2="16.65"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  grid: {
    path: [
      '<rect x="3" y="3" width="7" height="7"></rect>',
      '<rect x="14" y="3" width="7" height="7"></rect>',
      '<rect x="14" y="14" width="7" height="7"></rect>',
      '<rect x="3" y="14" width="7" height="7"></rect>'
    ],
    viewBox: '0 0 24 24'
  },
  shapes: {
    viewBox: '0 0 24 24',
    path: [
      '<path d="M16.9707 12.25V16.75C16.9707 20.5 15.4707 22 11.7207 22H7.2207C3.4707 22 1.9707 20.5 1.9707 16.75V12.25C1.9707 8.5 3.4707 7 7.2207 7H11.7207C15.4707 7 16.9707 8.5 16.9707 12.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',
      '<path opacity="0.4" d="M21.97 7.5C21.97 10.37 19.78 12.72 16.97 12.97V12.25C16.97 8.5 15.47 7 11.72 7H11C11.25 4.19 13.6 2 16.47 2C19.26 2 21.56 4.07 21.91 6.77C21.95 7 21.97 7.25 21.97 7.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>'
    ]
  },
  list: {
    path: [
      '<line x1="8" y1="6" x2="21" y2="6"></line>',
      '<line x1="8" y1="12" x2="21" y2="12"></line>',
      '<line x1="8" y1="18" x2="21" y2="18"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  user: {
    path: [
      '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>',
      '<circle cx="12" cy="7" r="4"></circle>'
    ],
    viewBox: '0 0 24 24'
  },
  users: {
    path: [
      '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>',
      '<circle cx="9" cy="7" r="4"></circle>',
      '<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>',
      '<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  userPlus: {
    path: [
      '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>',
      '<circle cx="8.5" cy="7" r="4"></circle>',
      '<line x1="20" y1="8" x2="20" y2="14"></line>',
      '<line x1="23" y1="11" x2="17" y2="11"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  camera: {
    viewBox: '0 0 24 24',
    path: [
      '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>',
      '<circle cx="12" cy="13" r="4"></circle>'
    ]
  },
  trash2: {
    viewBox: '0 0 24 24',
    path: [
      '<polyline points="3 6 5 6 21 6"></polyline>',
      '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
      '<line x1="10" y1="11" x2="10" y2="17"></line>',
      '<line x1="14" y1="11" x2="14" y2="17"></line>'
    ]
  },
  save: {
    viewBox: '0 0 24 24',
    path: [
      '<path d="M4 3h13l3 3v15H4z"></path>',
      '<path d="M8 3v6h8V3"></path>',
      '<rect x="8" y="14" width="8" height="6"></rect>'
    ]
  },
  filter: {
    viewBox: '0 0 24 24',
    path: [
      '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>'
    ]
  },
  chevronDown: {
    path: [
      '<polyline points="6 9 12 15 18 9"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  ellipsis: {
    path: [
      '<circle cx="12" cy="12" r="1"></circle>',
      '<circle cx="19" cy="12" r="1"></circle>',
      '<circle cx="5" cy="12" r="1"></circle>'
    ],
    viewBox: '0 0 24 24'
  },
  clock: {
    path: [
      '<circle cx="12" cy="12" r="10"></circle>',
      '<polyline points="12 6 12 12 16 14"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  check: {
    path: [
      '<polyline points="20 6 9 17 4 12"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  x: {
    path: [
      '<line x1="18" y1="6" x2="6" y2="18"></line>',
      '<line x1="6" y1="6" x2="18" y2="18"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  chevronRight: {
    path: [
      '<polyline points="13 17 18 12 13 7"></polyline>',
      '<polyline points="6 17 11 12 6 7"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  chevronLeft: {
    path: [
      '<polyline points="11 18 6 13 11 8"></polyline>',
      '<polyline points="18 18 13 13 18 8"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  uploadCloud: {
    path: [
      '<polyline points="16 16 12 12 8 16"></polyline>',
      '<line x1="12" y1="12" x2="12" y2="21"></line>',
      '<path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  xCircle: {
    path: [
      '<circle cx="12" cy="12" r="10"></circle>',
      '<line x1="15" y1="9" x2="9" y2="15"></line>',
      '<line x1="9" y1="9" x2="15" y2="15"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  bookmark: {
    path: [
      '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  bookmarkFilled: {
    path: [
      '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" fill="currentColor"></path>'
    ],
    viewBox: '0 0 24 24'
  },  
  iaIcon: {
    path: [
      '<path xmlns="http://www.w3.org/2000/svg" d="M 87.782 19.553 C 73.209 23.086, 59.177 34.434, 52.813 47.834 C 49.920 53.924, 49.102 54.873, 46.358 55.324 C 40.548 56.277, 31.879 61.181, 25.567 67.086 C 15.961 76.072, 10.634 88.486, 11.129 100.729 C 11.346 106.086, 11.355 106.100, 14.423 105.800 L 17.500 105.500 18.209 97.680 C 19.110 87.745, 22.289 80.689, 29.122 73.464 C 34.781 67.481, 43.457 62.698, 50.820 61.502 C 53.498 61.067, 55.347 60.174, 55.685 59.150 C 59.866 46.513, 68.247 36.201, 78.805 30.704 C 108.159 15.423, 141.693 33.091, 146.430 66.333 L 147.594 74.500 155.547 75.099 C 171.055 76.266, 180.206 84.708, 181.820 99.336 C 182.487 105.380, 182.563 105.506, 185.711 105.810 L 188.923 106.121 188.661 99.228 C 188.051 83.198, 175.521 69.941, 159.408 68.278 C 154.539 67.776, 153.911 67.442, 153.438 65.108 C 150.329 49.789, 145.757 40.777, 136.961 32.630 C 123.590 20.245, 105.151 15.342, 87.782 19.553 M 55.750 94.080 C 54.422 94.854, 54 96.414, 54 100.550 L 54 106 57.500 106 C 60.722 106, 61 105.762, 61 103 L 61 100 100 100 L 139 100 139 103 C 139 105.762, 139.278 106, 142.500 106 L 146 106 146 100.535 C 146 96.156, 145.616 94.865, 144.066 94.035 C 141.442 92.631, 58.165 92.673, 55.750 94.080" stroke="none" fill="#ffff" fill-rule="evenodd" stroke-width="3"/>',
      '<path xmlns="http://www.w3.org/2000/svg" d="M 14.247 105.814 C 11.277 106.100, 11.048 106.361, 11.614 108.814 C 15.430 125.343, 29.910 137.717, 46.695 138.794 L 54 139.263 54 150.432 C 54 157.785, 54.410 162.010, 55.200 162.800 C 55.898 163.498, 59.244 164, 63.200 164 L 70 164 70 171.878 C 70 179.959, 71.282 182.873, 74.323 181.706 C 75.064 181.422, 81.082 177.321, 87.696 172.595 L 99.722 164 121.661 164 C 137.391 164, 143.940 163.660, 144.800 162.800 C 145.590 162.010, 146 157.788, 146 150.444 L 146 139.289 153.444 138.726 C 163.304 137.980, 171.185 134.406, 177.806 127.679 C 182.569 122.840, 186.987 114.977, 188.381 108.858 C 188.931 106.449, 188.683 106.182, 185.563 105.818 C 182.275 105.434, 182.095 105.588, 180.919 109.788 C 179.425 115.125, 173.985 122.673, 169.115 126.166 C 164.233 129.668, 156.978 132, 150.965 132 L 146 132 146 119 L 146 106 142.500 106 L 139 106 139 131.500 L 139 157 118.131 157 L 97.262 157 87.640 164 C 82.348 167.850, 77.789 171, 77.509 171 C 77.229 171, 77 168.562, 77 165.582 C 77 157.133, 76.866 157, 68.393 157 L 61 157 61 131.500 L 61 106 57.500 106 L 54 106 54 119 L 54 132 49.035 132 C 35.842 132, 23.804 123.231, 19.193 110.260 C 17.598 105.774, 17.313 105.518, 14.247 105.814 M 90.559 111.967 C 89.069 112.499, 87.496 116.361, 83.790 128.579 C 79.269 143.483, 79.073 144.580, 80.711 145.778 C 83.382 147.731, 85.204 146.856, 86.496 143 C 87.608 139.682, 87.932 139.484, 92.724 139.202 L 97.778 138.903 98.677 142.702 C 99.402 145.769, 100.028 146.500, 101.929 146.500 C 106.394 146.500, 106.316 144.261, 101.290 128.113 C 96.297 112.072, 95.140 110.331, 90.559 111.967 M 113.713 112.621 C 113.321 113.013, 113 120.403, 113 129.044 C 113 145.860, 113.582 147.902, 117.976 146.508 C 119.977 145.872, 120.038 145.285, 119.774 129.175 L 119.500 112.500 116.963 112.204 C 115.567 112.041, 114.104 112.229, 113.713 112.621 M 91.186 126.175 C 90.554 128.687, 89.755 131.475, 89.411 132.371 C 88.904 133.692, 89.472 134, 92.412 134 C 95.865 134, 96.006 133.868, 95.364 131.250 C 94.993 129.738, 94.160 126.949, 93.513 125.054 L 92.336 121.608 91.186 126.175" stroke="none" fill="#ffff" fill-rule="evenodd" stroke-width="3"/>',
    ],
    viewBox: '0 0 200 200'
  },
  baseIcon: {
    path: [
      '<polyline points="23 4 23 10 17 10"></polyline>',
      '<path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  edit: {
    path: [
      '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>',
      '<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  'edit-2': {
    path: [
      '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  whatsApp: {
    viewBox: '0 0 70 70',
    path: [
      '<path d="M35.66,35.67a16.71,16.71,0,0,1-7.75-6.78.82.82,0,0,1,.12-.95l1.55-1.69a.8.8,0,0,0,.15-.87l-2.44-4.65S26.21,19.08,24,20.5c0,0-5.81,4.54-2.1,10.78s7.2,8.35,10.34,9.88c2.73,1.33,8.64,3.1,12.21-3.39,0,0,1.25-2,0-2.51-.57-.23-3.68-1.77-5-2.41a.82.82,0,0,0-1,.22l-1.86,2.35A.81.81,0,0,1,35.66,35.67Z"/>',
      '<path d="M8.86,53.49l4-11.2a23,23,0,1,1,8.64,8.8Z" stroke-linecap="round"/>'
    ]
  },
  mail: {
    viewBox: '0 0 48 48',
    path: [
      '<path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M9.74,37.21H40.33A3.17,3.17,0,0,0,43.5,34V12.91a2.12,2.12,0,0,0-2.11-2.12H10.8a1.06,1.06,0,0,0-.63,1.91L25.54,24,42.42,11.59"/>',
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" x1="11.86" y1="29.25" x2="19.08" y2="23.26"/>',
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" x1="9.94" y1="30.84" x2="8.48" y2="32.05"/>',
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" x1="8.82" y1="22.62" x2="13.36" y2="18.91"/>',
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" x1="6.9" y1="24.21" x2="5.44" y2="25.42"/>',
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" x1="16.25" y1="21.03" x2="14.51" y2="22.47"/>',
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" x1="12.55" y1="24.1" x2="4.5" y2="30.78"/>'
    ]
  },
  menu: {
    path: [
      '<path stroke-width="2" d="M0 0h20v2H0zM0 7h20v2H0zM0 14h20v2H0z"/>',
    ],
    viewBox: '0 0 20 16'
  },
  add: {
    path: [
      '<path stroke-width="2" d="M416 277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416v42.666z"/>',
    ],
    viewBox: '0 0 512 512'
  },
  copy: {
    path: [
      '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>',
      '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>'
    ],
    viewBox: '0 0 24 24' 
  },
  drag: {
    path: [
      '<path d="M3 6h18M3 12h18M3 18h18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
    ],
    viewBox: '0 0 24 24'
  },
  calendar: {
    path: [
      '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>',
      '<line x1="16" y1="2" x2="16" y2="6"></line>',
      '<line x1="8" y1="2" x2="8" y2="6"></line>',
      '<line x1="3" y1="10" x2="21" y2="10"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  plusSquare: {
    path: [
      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
      '<line x1="12" y1="8" x2="12" y2="16"></line>',
      '<line x1="8" y1="12" x2="16" y2="12"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  plusLg: {
    path: [
      '<path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>'
    ],
    viewBox: '0 0 16 16'
  },
  plus: {
    path: [
      '<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" stroke-width="0.5" fill="currentColor"/>'
    ],
    viewBox: '0 0 16 16'
  },
  type: {
    path: [
      '<path d="M4 7V4h16v3"></path>',
      '<line x1="9" y1="20" x2="15" y2="20"></line>',
      '<line x1="12" y1="4" x2="12" y2="20"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  square: {
    path: [
      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>'
    ],
    viewBox: '0 0 24 24'
  },
  'arrow-right': {
    path: [
      '<line x1="5" y1="12" x2="19" y2="12"></line>',
      '<polyline points="12 5 19 12 12 19"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  'edit-3': {
    path: [
      '<path d="M12 20h9"></path>',
      '<path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  'rotate-ccw': {
    path: [
      '<polyline points="1 4 1 10 7 10"></polyline>',
      '<path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  trash: {
    path: [
      '<polyline points="3 6 5 6 21 6"></polyline>',
      '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  mic: {
    path: [
      '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>',
      '<path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>',
      '<line x1="12" y1="19" x2="12" y2="23"></line>',
      '<line x1="8" y1="23" x2="16" y2="23"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  stop: {
    path: [
      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>'
    ],
    viewBox: '0 0 24 24'
  },
  maximize: {
    path: [
      '<polyline points="15 3 21 3 21 9"></polyline>',
      '<polyline points="9 21 3 21 3 15"></polyline>',
      '<line x1="21" y1="3" x2="14" y2="10"></line>',
      '<line x1="3" y1="21" x2="10" y2="14"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  download: {
    path: [
      '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>',
      '<polyline points="7 10 12 15 17 10"></polyline>',
      '<line x1="12" y1="15" x2="12" y2="3"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  chartBar: {
    path: [
      '<path d="M9 17v-2m3 2v-4m3 4v-6M9 5h6l3 3v11a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z" stroke-linecap="round" stroke-linejoin="round"/>'
    ],
    viewBox: '0 0 24 24'
  },
  fileDownload: {
    path: [
      '<path d="M12 16v-8m0 8l-4-4m4 4l4-4M4 20h16a2 2 0 002-2V7.828a2 2 0 00-.586-1.414l-4.828-4.828A2 2 0 0014.172 1H6a2 2 0 00-2 2v15a2 2 0 002 2z" stroke-linecap="round" stroke-linejoin="round"/>'
    ],
    viewBox: '0 0 24 24'
  },
  refresh: {
    path: [
      '<polyline points="23 4 23 10 17 10"></polyline>',
      '<polyline points="1 20 1 14 7 14"></polyline>',
      '<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  info: {
    path: [
      '<circle cx="12" cy="12" r="10"></circle>',
      '<line x1="12" y1="16" x2="12" y2="12"></line>',
      '<line x1="12" y1="8" x2="12.01" y2="8"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  marker: {
    path: [
      '<path d="M20.953125 20.585938C20.976562 20.585938 21.464844 20.863281 21.464844 21.484375C21.464844 22.058594 21.132812 22.328125 21.105469 22.328125L12.585938 22.3125C12.585938 22.3125 12.230469 22.0625 12.21875 21.480469C12.203125 20.859375 12.777344 20.570312 12.777344 20.570312ZM5.445312 17.816406L8.683594 19.773438L7.3125 21.976562L3.765625 22.007812C3.765625 22.007812 3.488281 21.90625 3.328125 21.683594C3.175781 21.472656 3.148438 21.140625 3.113281 21.0625C3.042969 20.886719 3.441406 20.238281 3.441406 20.238281C3.476562 20.238281 5.492188 17.816406 5.445312 17.816406ZM7.480469 11.90625C8.128906 12 14.816406 16.753906 13.980469 16.046875L13.230469 17.1875C13.039062 17.507812 12.207031 18.441406 11.851562 18.378906C10.964844 18.226562 10.230469 18.273438 9.726562 19.011719L8.96875 19.628906L5.691406 17.582031L6.535156 16.183594C6.597656 15.71875 6.199219 14.992188 6.097656 14.597656C6.011719 14.257812 6.230469 13.433594 6.453125 13.152344ZM16.167969 2.585938C16.289062 2.5 20.175781 4.988281 20.023438 5.097656C20.222656 5.222656 20.445312 6.167969 20.332031 6.359375C20.539062 6.371094 14.265625 15.636719 14.109375 15.832031L7.691406 11.667969C11.484375 7.070312 15.347656 2.183594 15.027344 2.777344C15.175781 2.582031 16.167969 2.585938 16.167969 2.585938ZM4.066406 22.261719L7.429688 22.238281L8.902344 20.011719L10.117188 19.019531C10.316406 18.730469 10.667969 18.578125 11.003906 18.640625C11.933594 18.808594 12.753906 18.421875 13.222656 17.640625L20.351562 6.949219C20.84375 6.128906 20.601562 5.082031 19.804688 4.5625L16.847656 2.65625C16.050781 2.140625 14.957031 2.328125 14.371094 3.074219L6.261719 12.992188C5.679688 13.730469 5.636719 14.742188 6.152344 15.507812C6.335938 15.785156 6.328125 16.15625 6.128906 16.445312L5.421875 17.476562L3.105469 20.285156C2.792969 20.664062 2.730469 21.175781 2.949219 21.613281C3.167969 22.050781 3.566406 22.261719 4.066406 22.261719Z" fill="currentColor" fill-rule="evenodd"/>'
    ],
    viewBox: '0 0 25 25'
  },
  pause: {
    path: [
      '<rect x="6" y="4" width="4" height="16"></rect>',
      '<rect x="14" y="4" width="4" height="16"></rect>'
    ],
    viewBox: '0 0 24 24'
  },
  play: {
    path: [
      '<polygon points="5 3 22 12 5 21 5 3"></polygon>'
    ],
    viewBox: '0 0 24 24'
  },
  documentoAi: {
    path: [
      // Fundo branco do papel
      '<path fill="#ffffff" d="M87.85 6.19H16.8v115.45h94.62V28.8z"></path>',
      
      // Linhas coloridas dentro do papel
      '<path d="M33.34 41.05H94.5" stroke="#FF6B6B" stroke-width="3.865" stroke-linecap="round" stroke-miterlimit="10"></path>',
      '<path d="M33.34 55.68H94.5" stroke="#4ECDC4" stroke-width="3.865" stroke-linecap="round" stroke-miterlimit="10"></path>',
      '<path d="M33.34 70.3H94.5" stroke="#45B7D1" stroke-width="3.865" stroke-linecap="round" stroke-miterlimit="10"></path>',
      '<path d="M33.34 84.93H94.5" stroke="#96CEB4" stroke-width="3.865" stroke-linecap="round" stroke-miterlimit="10"></path>',
      '<path d="M33.34 99.56h26.15" stroke="#FFD93D" stroke-width="3.865" stroke-linecap="round" stroke-miterlimit="10"></path>',
      
      // Borda externa do documento
      '<path d="M109.45 23.59L92.79 6.88A10.555 10.555 0 0 0 85.54 4h-68.5c-1.55 0-2.81 1.26-2.81 2.81v114.38c0 1.55 1.26 2.81 2.81 2.81h93.93c1.55 0 2.81-1.26 2.81-2.81V31.28c-.01-2.91-2.21-5.69-4.33-7.69zm.32 96.41H18.23V8h64.66c2.12 0 3.85 1.72 3.85 3.85v17.88h17.34c3.14 0 5.69 1.73 5.69 5.69V120z" fill="#6fbff0"></path>'
    ],
    viewBox: '0 0 128 128'
  },
  'help-circle': {
    path: [
      '<circle cx="12" cy="12" r="10"></circle>',
      '<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>',
      '<line x1="12" y1="17" x2="12.01" y2="17"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  // Ícone Central de Ajuda (headset) – usar com fill="currentColor" para cor branca
  centralAjuda: {
    path: [
      '<path d="M440.367,440.415l-10.173-29.91c-19.102-56.262-70.83-94.605-129.763-97.121c-5.187,4.03-10.655,7.493-16.322,10.521c-8.449,22.185-36.836,28.195-53.468,11.205c-19.676-1.738-37.69-9.511-53.422-21.725c-58.933,2.508-110.647,40.851-129.763,97.121L37.3,440.415c-2.936,8.603-1.522,18.084,3.774,25.469c5.279,7.391,13.821,11.771,22.906,11.771h349.693c9.083,0,17.626-4.379,22.906-11.771C441.873,458.499,443.286,449.018,440.367,440.415z"/>',
      '<path d="M277.758,290.619c34.212-24.047,58.141-77.151,58.141-128.491c0-145.907-194.133-145.752-194.133,0c0,62.397,35.33,127.303,81.546,139.556c4.456-12.626,16.382-21.757,30.515-21.757C263.331,279.926,271.81,284.095,277.758,290.619z"/>',
      '<path d="M99.169,223.042c4.813,18.906,31.044,13.704,31.044-3.805c0-70.178,3.354-76.731-6.041-84.348C145.679,2.361,330.946,3.355,353.495,134.904c-9.381,7.641-6.025,14.163-6.025,84.333c0,5.489,2.95,10.095,7.189,12.952c0,54.594-22.145,51.402-88.736,69.052c-10.295-11.174-28.683-3.899-28.683,11.173c0,18.876,27.053,23.293,32.302,4.318c53.762-14.256,101.018-18.752,101.018-72.484v-11.027c3.991-2.066,6.817-5.729,7.951-10.179c51.822-1.056,51.838-78.719,0-79.775c-1.072-4.24-3.711-7.703-7.423-9.815c1.336-15.902-1.94-36.805-11.057-56.985C296.626-54.368,109.355-3.176,106.422,123.622c-0.404,4.294-0.078,7.338,0.17,9.83c-3.712,2.112-6.351,5.575-7.423,9.815c-21.71,0.419-39.212,18.084-39.212,39.888C59.957,204.958,77.459,222.622,99.169,223.042z"/>'
    ],
    viewBox: '0 0 477.655 477.655'
  },
  'trending-up': {
    path: [
      '<polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>',
      '<polyline points="16 7 22 7 22 13"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  'trending-down': {
    path: [
      '<polyline points="22 17 13.5 8.5 8.5 13.5 2 7"></polyline>',
      '<polyline points="16 17 22 17 22 11"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  'mdi-file-chart': {
    path: [
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"></path>',
      '<line x1="14" y1="13" x2="20" y2="13"></line>',
      '<line x1="14" y1="17" x2="20" y2="17"></line>',
      '<line x1="14" y1="21" x2="20" y2="21"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  'rotate-right': {
    path: [
      '<polyline points="1 4 1 10 7 10"></polyline>',
      '<path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  'rotate-left': {
    path: [
      '<polyline points="23 4 23 10 17 10"></polyline>',
      '<path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  'rotate-180': {
    path: [
      '<polyline points="1 4 1 10 7 10"></polyline>',
      '<polyline points="23 20 23 14 17 14"></polyline>',
      '<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  'rotate-cw': {
    path: [
      '<path d="M202.621,105.207H101.31V3.897C101.31,1.745,99.567,0,97.414,0H3.897C1.743,0,0,1.745,0,3.897V136.38c0,2.152,1.743,3.897,3.897,3.897h62.345v62.345c0,2.152,1.743,3.897,3.897,3.897h132.483c2.154,0,3.897-1.745,3.897-3.897v-93.517C206.517,106.952,204.774,105.207,202.621,105.207z M70.138,105.207c-2.154,0-3.897,1.745-3.897,3.897v23.379H7.793V7.793h85.724v97.414H70.138z M74.034,198.724v-62.345V113h23.379h101.31v85.724H74.034z" stroke-width="10"/>',
      '<path d="M136.379,31.172c0,2.152,1.743,3.897,3.897,3.897c19.338,0,35.069,15.733,35.069,35.069c0,2.152,1.743,3.897,3.897,3.897s3.897-1.745,3.897-3.897c0-23.634-19.228-42.862-42.862-42.862C138.122,27.276,136.379,29.021,136.379,31.172z" stroke-width="10"/>',
      '<path d="M137.521,50.459c0.761,0.761,1.758,1.142,2.755,1.142s1.994-0.381,2.755-1.142c1.522-1.522,1.522-3.988,0-5.51l-13.775-13.777l13.775-13.777c1.522-1.522,1.522-3.988,0-5.51c-1.522-1.522-3.988-1.522-5.51,0l-16.53,16.532c-1.522,1.522-1.522,3.988,0,5.51L137.521,50.459z" stroke-width="10"/>',
      '<path d="M165.466,67.385c-1.522-1.522-3.988-1.522-5.51,0c-1.522,1.522-1.522,3.988,0,5.51l16.53,16.532c0.731,0.731,1.72,1.142,2.755,1.142c1.035,0,2.024-0.411,2.755-1.142l16.53-16.532c1.522-1.522,1.522-3.988,0-5.51c-1.522-1.522-3.988-1.522-5.51,0l-13.774,13.777L165.466,67.385z" stroke-width="10"/>'
    ],
    viewBox: '0 0 206.519 206.519'
  },
  starsIa: {
    path: [
      '<path d="M23.426,31.911l-1.719,3.936c-0.661,1.513 -2.754,1.513 -3.415,0l-1.719,-3.936c-1.529,-3.503 -4.282,-6.291 -7.716,-7.815l-4.73,-2.1c-1.504,-0.668 -1.504,-2.855 0,-3.523l4.583,-2.034c3.522,-1.563 6.324,-4.455 7.827,-8.077l1.741,-4.195c0.646,-1.557 2.797,-1.557 3.443,0l1.741,4.195c1.503,3.622 4.305,6.514 7.827,8.077l4.583,2.034c1.504,0.668 1.504,2.855 0,3.523l-4.73,2.1c-3.434,1.524 -6.187,4.313 -7.716,7.815z"/>',
      '<path d="M38.423,43.248l-0.493,1.131c-0.361,0.828 -1.507,0.828 -1.868,0l-0.493,-1.131c-0.879,-2.016 -2.464,-3.621 -4.44,-4.5l-1.52,-0.675c-0.822,-0.365 -0.822,-1.56 0,-1.925l1.435,-0.638c2.027,-0.901 3.64,-2.565 4.504,-4.65l0.507,-1.222c0.353,-0.852 1.531,-0.852 1.884,0l0.507,1.222c0.864,2.085 2.477,3.749 4.504,4.65l1.435,0.638c0.822,0.365 0.822,1.56 0,1.925l-1.52,0.675c-1.978,0.879 -3.562,2.484 -4.442,4.5z"/>'
    ],
    viewBox: '0 0 48 48'
  },
  scissors: {
    path: [
      '<circle cx="6" cy="6" r="3"></circle>',
      '<circle cx="6" cy="18" r="3"></circle>',
      '<line x1="20" y1="4" x2="8.12" y2="15.88"></line>',
      '<line x1="14.47" y1="14.48" x2="20" y2="20"></line>',
      '<line x1="8.12" y1="8.12" x2="12" y2="12"></line>'
    ],
    viewBox: '0 0 24 24'
  },
  crop: {
    path: [
      '<path d="M0 28v4h4v-1.984h-1.984v-2.016h-2.016zM0 4h2.016v-1.984h1.984v-2.016h-4v4zM4 28h24v-24h-24v24zM8 24v-16h16v16h-16zM10.016 22.016h2.656q-0.352-0.16-0.768-0.608t-1.056-1.28-0.832-1.12v3.008zM10.016 12q0 0.832 0.576 1.44t1.408 0.576 1.408-0.576 0.608-1.44-0.608-1.408-1.408-0.576-1.408 0.576-0.576 1.408zM13.216 22.016h8.8v-7.328q-0.48-0.512-0.96-0.608t-0.992 0.16-0.96 0.8-1.024 1.184-0.992 1.408-1.024 1.472-0.96 1.344-0.96 1.024-0.928 0.544zM28 30.016v1.984h4v-4h-1.984v2.016h-2.016zM28 2.016h2.016v1.984h1.984v-4h-4v2.016z"/>'
    ],
    viewBox: '0 0 32 32'
  },
  restore: {
    path: [
      '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>',
      '<path d="M21 3v5h-5"></path>',
      '<path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>',
      '<path d="M3 21v-5h5"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  eye: {
    path: [
      '<path d="M21.257 10.962c.474.62.474 1.457 0 2.076C19.764 14.987 16.182 19 12 19c-4.182 0-7.764-4.013-9.257-5.962a1.692 1.692 0 0 1 0-2.076C4.236 9.013 7.818 5 12 5c4.182 0 7.764 4.013 9.257 5.962z" />',
      '<circle cx="12" cy="12" r="3" />'
    ],
    viewBox: '0 0 24 24'
  },
  'eye-off': {
    path: [
      '<path d="M21.257 10.962c.474.62.474 1.457 0 2.076C19.764 14.987 16.182 19 12 19c-4.182 0-7.764-4.013-9.257-5.962a1.692 1.692 0 0 1 0-2.076C4.236 9.013 7.818 5 12 5c4.182 0 7.764 4.013 9.257 5.962z" />',
      '<circle cx="12" cy="12" r="3" />',
      '<line x1="1" y1="1" x2="23" y2="23" />'
    ],
    viewBox: '0 0 24 24'
  },
  resourceLink: {
    path: [
      '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>',
      '<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>'
    ],
    viewBox: '0 0 24 24'
  },
  resourceFile: {
    path: [
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>',
      '<polyline points="14 2 14 8 20 8"></polyline>',
      '<line x1="16" y1="13" x2="8" y2="13"></line>',
      '<line x1="16" y1="17" x2="8" y2="17"></line>',
      '<polyline points="10 9 9 9 8 9"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  resourceVideo: {
    path: [
      '<polygon points="23 7 16 12 23 17 23 7"></polygon>',
      '<rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>'
    ],
    viewBox: '0 0 24 24'
  },
  resourceImage: {
    path: [
      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
      '<circle cx="8.5" cy="8.5" r="1.5"></circle>',
      '<polyline points="21 15 16 10 5 21"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  resourceAudio: {
    path: [
      '<path d="M9 18V5l12-2v13"></path>',
      '<circle cx="6" cy="18" r="3"></circle>',
      '<circle cx="18" cy="16" r="3"></circle>'
    ],
    viewBox: '0 0 24 24'
  },
  resourceDocument: {
    path: [
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>',
      '<polyline points="14 2 14 8 20 8"></polyline>',
      '<line x1="16" y1="13" x2="8" y2="13"></line>',
      '<line x1="16" y1="17" x2="8" y2="17"></line>',
      '<polyline points="10 9 9 9 8 9"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  resourcePdf: {
    path: [
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>',
      '<polyline points="14 2 14 8 20 8"></polyline>',
      '<line x1="16" y1="13" x2="8" y2="13"></line>',
      '<line x1="16" y1="17" x2="8" y2="17"></line>',
      '<polyline points="10 9 9 9 8 9"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  resourceContent: {
    path: [
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>',
      '<polyline points="14 2 14 8 20 8"></polyline>',
      '<line x1="16" y1="13" x2="8" y2="13"></line>',
      '<line x1="16" y1="17" x2="8" y2="17"></line>',
      '<polyline points="10 9 9 9 8 9"></polyline>'
    ],
    viewBox: '0 0 24 24'
  },
  paperclip: {
    path: [
      '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>'
    ],
    viewBox: '0 0 24 24'
  }
};

// Depois validamos os ícones
Object.entries(icons).forEach(([name, icon]) => {
  if (!validateIcon(icon)) {
    console.warn(`Ícone "${name}" está mal configurado`);
  }
}); 